import API from '@/api'

export default {
  namespaced: true,
  state: {
    data: [],
    loaded: false,

    currencies: [],
    languages: [],
    version: ''
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    load(state) {
      state.loaded = true;
    },

    saveCurrencies(state, data) {
      // console.log(data);
      state.currencies = data;
    },
    saveLanguages(state, data) {
      state.languages = data;
    },
    setVersion(state, data) {
      state.version = data;
    }
  },
  actions: {

    loadTillage(context, payload) {
      return API.misc.getTillage().then(res => {
        context.commit('saveData', res.data.data);
        context.commit('load');
      });

    },

    loadCurrencies(ctx) {
      return API.misc.getCurrencies().then(res => {
        ctx.commit('saveCurrencies', res.data.data);
      });
    },
    loadLanguages(ctx) {
      return API.misc.getLanguages().then(res => {
        // console.log(res);
        ctx.commit('saveLanguages', res.data);
      });
    }
  },
  getters: {
    data(state) {
      return state.data;
    },

    getTillageForSelector(state) {
      let data = state.data.map(function(el) {
        return {
          key : el.id,
          label : el.tillageValue,
          value : el.id,
        }
      } );
      return data;
    },

    currencies(state) {
      return state.currencies;
    },
    getLanguagesValue(state) {
      return state.languages;
    },
    getVersion(state) {
      return state.version;
    }

    // getFieldsForSelector : state => farmId =>  {
    //   let farmFields = state.data.find(n => n.id === farmId)
    //   let data = farmFields.fields.map(function(el) {
    //     return {
    //       key : el.id,
    //       label : el.name,
    //       value : el.id,
    //     }
    //   } );
    //   return data;
    // }
  }
}
